import { render } from "./GenerationValue.vue?vue&type=template&id=5cf22e67"
import script from "./GenerationValue.vue?vue&type=script&lang=js"
export * from "./GenerationValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__